import { useEffect, useState } from "react";
import { axiosGetWithHeader, ShowAlertError } from "../Common/axios";
import { AppHeader } from "./AppHeader";
import { useLocation } from "react-router-dom";
import Spinner from 'react-bootstrap/Spinner';
import { AppFooter } from "./AppFooter";

import { KPBasicChart } from './KPPage/KPBasicChart';
import { KPAspectChart } from './KPPage/KPAspectChart';
import { KPConjoinedPlanetsChart } from './KPPage/KPConjoinedPlanetsChart';
import { KPPlanetSchedule } from './KPPage/KPPlanetSchedule';
import { AstrologerInfoFooter } from "../Common/AstrologerInfoFooter";
import { KPLinksChart } from "./KPPage/KPLinksChart";
import { KPInterLinksMenu } from "./KPInterLinksMenu";

export function KPInterLinks()  {
  const {state} = useLocation();
  const runningId = state?state.runningId:null;
  const [userData, setUserData] = useState(null);
  const [clientData, setClientData] = useState(null);
  const [menuArray, setMenuArray] = useState([]);
  const [spinner, setSpinner] = useState('Loading - Basic Chart Page');
  const [errorAlert, setErrorAlert] = useState(null);

  function handleMenu(menuArray){
    setMenuArray(menuArray)
  }

  useEffect(() => {
    axiosGetWithHeader("/userrequest/"+runningId,
      (response)=>{
        setUserData(response.data);
        getClientData(response.data.id);
        setSpinner(null);
      },
      (error)=>{
        setUserData(null);
        setSpinner(null);
        console.log(error);
        setErrorAlert(error.message);
      }
    );

    function getClientData(clientId) {
      axiosGetWithHeader("/chart/userdata/"+clientId,
        (response)=>{
          setClientData(response.data);
        },
        (error)=>{
          console.log(error);
          setClientData(null);
          setErrorAlert(error.message);
        }
      );
    }
  }, [runningId]);

  return (
    <>
        <div class="m-0 p-0 row sticky-top bg-white noprint">
            <div class="m-0 p-0 col-sm-12 col-md-12">
                <AppHeader/>
                <KPInterLinksMenu userData={userData} handleMenu={handleMenu} />
            </div>    
        </div> 
        {spinner===null?<></>:<>{spinner} <Spinner animation="border" size="sm" /></>}
        { clientData===null || clientData===undefined || clientData.length===0 || userData===null || userData===undefined || userData.length===0?<></>:
        <>
        <div class="m-0 p-0 row align-items-top content">
            <div class="m-0 p-0 col-sm-12 col-md-12">
              <div class="menupageheight">
                <KPBasicChart menuArray={menuArray} userData={userData} clientData={clientData}/>
                <KPLinksChart menuArray={menuArray} userData={userData} />
                <KPAspectChart menuArray={menuArray} userData={userData} />
                <KPConjoinedPlanetsChart menuArray={menuArray} userData={userData} />
                <KPPlanetSchedule menuArray={menuArray} userData={userData} clientData={clientData} setErrorAlert={setErrorAlert}/>
              </div>  
            </div>
        </div>
        <div class="m-0 p-0 row noprint">
            <div class="m-0 p-0 col-sm-12 col-md-12">
                <AppFooter/>
            </div>    
        </div>
        <div class="m-0 p-0 row d-none d-print-block printfooter">
          <div class="m-0 p-0 col-sm-12 col-md-12">
            <AstrologerInfoFooter userData={userData}  />
          </div>    
        </div> 
        </>}
        <ShowAlertError errorAlert={errorAlert} setErrorAlert={setErrorAlert}/>
    </>
  );
}
